import { HorizontalFlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const TitleContainer = styled(HorizontalFlexDiv)`
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`
export const Title = styled.div`
    font-size: 16px;
    font-weight: 500;
`